import { FC, useCallback, useEffect, useContext, useMemo } from 'react';
import { Box, Select } from '@robocorp/components';
import { useTranslation } from 'react-i18next';
import { VariablesContext } from '../context';
import { useActions, useSelector } from '../../../../hooks';

export const SelectProcessId: FC = () => {
  const { endpoint, variables, setVariables } = useContext(VariablesContext);
  const { t } = useTranslation();

  const loadingProcesses = useSelector(({ entityStates }) => entityStates.processes.loading);
  const processById = useSelector(({ workspaceResources }) => workspaceResources.processes.byId);

  const { getProcesses } = useActions(({ processActions }) => ({
    getProcesses: processActions.getProcesses,
  }));

  const processItems = useMemo(
    () =>
      Object.entries(processById).map(([id, process]) => {
        return {
          label: process.name,
          value: id,
        };
      }),
    [processById],
  );

  useEffect(() => {
    if (endpoint.includes('processId')) {
      getProcesses();
    }
  }, [endpoint]);

  const onChange = useCallback(
    (processId: string) => {
      setVariables({
        processId,
        processRunId: undefined,
        robotRunId: undefined,
        workItemId: undefined,
      });
    },
    [setVariables],
  );

  let placeholder = processItems.length ? `${t('choose')}...` : t('noProcesses');
  if (loadingProcesses) {
    placeholder = t('loading');
  }

  return !endpoint.includes('processId') ? null : (
    <Box mb={20}>
      <Select
        label={t('chooseProcess')}
        items={processItems}
        onChange={onChange}
        disabled={loadingProcesses || processItems.length < 1}
        value={variables.processId}
        placeholder={placeholder}
      />
    </Box>
  );
};
